<script setup lang="ts">
  import { useAppStore } from '@/stores/app'

  const app = useAppStore()
</script>

<template>
  <div class="flex flex-wrap">
    <template
      v-for="(item, i) in app.breadcrumb"
      :key="item.label">
      <app-button
        class="font-bold"
        :to="item.route">
        {{ item.label }}
      </app-button>
      <div
        v-if="i < app.breadcrumb.length-1"
        class="px-2">
        /
      </div>
    </template>
  </div>
</template>
